import { Menu, Transition } from "@headlessui/react";
import clsx from "clsx";
import { Fragment, ReactNode } from "react";

import { ArrowDown } from "@/assets/icons/icons";
import { useIsMobile } from "@/hooks/useIsMobile";
type CollapsibleProps = {
  id: string;
  icon?: ReactNode;
  label: string;
  children: ReactNode;
};
export const Collapsible = ({
  id,
  icon,
  label,
  children,
}: CollapsibleProps) => {
  const isMobile = useIsMobile();

  return (
    <Menu
      as="div"
      data-testid={`collapsible-${id}`}
      className="relative inline-block text-left"
    >
      {({ open }) => (
        <>
          <Menu.Button
            tabIndex={0}
            aria-label={label}
            className={clsx(
              "group flex items-center gap-2 py-2 text-lg text-white hover:font-semibold focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 xl:py-0",
              open && "!font-semibold",
            )}
          >
            <div className="flex h-10 items-center justify-center border-transparent group-hover:border-white group-hover:bg-transparent xl:h-10 xl:w-10 xl:rounded-full xl:border-2 xl:bg-white">
              {icon}
            </div>
            <span className="font-inherit my-auto whitespace-nowrap pb-px text-white xl:hidden">
              {label}
            </span>
            <ArrowDown
              className={clsx(
                "stroke-white transition ease-linear xl:hidden",
                open && "rotate-180",
              )}
            />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform md:-translate-y-full opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              id={`collapsible-menu-${id}`}
              className={clsx(
                "font-small bottom-0 left-0 z-20 ml-14 origin-bottom whitespace-nowrap pt-6 text-white shadow-none focus:outline-none md:absolute md:-top-3 md:bottom-auto md:mb-4 md:ml-0 md:origin-top-left md:bg-white md:p-4 md:text-primary-100 md:shadow-lg md:ring-1 md:ring-black md:ring-opacity-5",
                isMobile && "w-screen",
              )}
            >
              {children}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};
